var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "default-page" } }, [
    _c("div", { staticClass: "container full-width" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("h2", [
            _vm._v("\n                    Send Recommends\n                ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row send-list-select-date" }, [
            _c("div", { staticClass: "col-md-4 col-sm-12" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.auctionDate,
                      expression: "auctionDate"
                    }
                  ],
                  attrs: { name: "auction_date", id: "auction_date" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.auctionDate = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function($event) {
                        return _vm.getFavList()
                      }
                    ]
                  }
                },
                _vm._l(_vm.dates, function(date) {
                  return _c("option", { domProps: { value: date.value } }, [
                    _vm._v(
                      _vm._s(date.label) + "\n                            "
                    )
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c(
                  "b-alert",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSuccess,
                        expression: "showSuccess"
                      }
                    ],
                    attrs: { show: _vm.dismissCountDown, variant: "success" }
                  },
                  [
                    _vm._v(
                      "Email sent\n                            successfully.\n                        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("messages", { attrs: { messages: _vm.messages } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.total > 0
            ? _c("div", [
                _vm.userListActive
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "link back",
                          on: { click: _vm.changeUserList }
                        },
                        [_vm._v("back to list")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("strong", [_vm._v("Showing")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.from))]),
                _vm._v("-"),
                _c("span", [_vm._v(_vm._s(_vm.to))]),
                _vm._v(" of "),
                _c("span", [_vm._v(_vm._s(_vm.total))]),
                _vm._v("\n                    results\n                ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                class: _vm.userListActive
                  ? "col-md-6 tag-list-container mobile-hide"
                  : "col-md-12 mobile-show"
              },
              [
                _c("b-table", {
                  ref: "favouritesTable",
                  staticClass: "list-table favourite-list-table",
                  attrs: {
                    fields: _vm.fields,
                    items: _vm.favourites,
                    "show-empty": "",
                    selectable: "",
                    "select-mode": "single"
                  },
                  on: {
                    "row-selected": _vm.onRowSelected,
                    "row-clicked": _vm.onRowClicked
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "empty",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n                            You have no favourite list...\n                        "
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(last_sent)",
                      fn: function(data) {
                        return [
                          data.item.recommends && data.item.recommends.length
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.dateToMoment(
                                        data.item.recommends[0].created_at
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "cell(name)",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex d-xl-inline-block align-items-center justify-content-between"
                            },
                            [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(data.item.name))
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "counter" },
                                [
                                  data.item.id === 0
                                    ? [
                                        _vm._v(
                                          "\n                                    (" +
                                            _vm._s(_vm.all_favourites_count) +
                                            ")\n                                "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                                    (" +
                                            _vm._s(data.item.vehicles_count) +
                                            ")\n                                "
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.createList,
                          expression: "createList"
                        }
                      ],
                      staticClass: "col-md-12"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "create-list",
                          on: {
                            click: function($event) {
                              return _vm.addToList()
                            }
                          }
                        },
                        [
                          _vm._v("Create List "),
                          _c("i", { staticClass: "fa fa-plus-circle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.listBox,
                          expression: "listBox"
                        }
                      ],
                      staticClass: "col-sm-12 col-md-4"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.listName,
                            expression: "listName"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          type: "text",
                          name: "listName",
                          id: "listName"
                        },
                        domProps: { value: _vm.listName },
                        on: {
                          keydown: function($event) {
                            return _vm.storeList($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.listName = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.userListActive
              ? _c(
                  "div",
                  {
                    class: this.userListActive
                      ? "col-md-6 user-list-container mobile-show"
                      : "mobile-hide col-md-6 user-list-container"
                  },
                  [
                    _c("b-table", {
                      staticClass: "list-table favourite-list-user-table",
                      attrs: {
                        fields: _vm.user_fields,
                        items: _vm.currentUsers,
                        "show-empty": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "empty",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                            No members are added to list...\n                        "
                                )
                              ]
                            }
                          },
                          {
                            key: "head(sendEmail)",
                            fn: function(scope) {
                              return [
                                _c("span", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.sendMailAll,
                                        expression: "sendMailAll"
                                      }
                                    ],
                                    attrs: {
                                      id: "send_mail_all",
                                      type: "checkbox"
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.sendMailAll)
                                        ? _vm._i(_vm.sendMailAll, null) > -1
                                        : _vm.sendMailAll
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = _vm.sendMailAll,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.sendMailAll = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.sendMailAll = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.sendMailAll = $$c
                                          }
                                        },
                                        _vm.onSendMailAll
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "send_mail_all" }
                                  })
                                ]),
                                _vm._v(
                                  "\n                            Send Email\n                        "
                                )
                              ]
                            }
                          },
                          {
                            key: "head(notify)",
                            fn: function(scope) {
                              return [
                                _c("span", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.notifyAll,
                                        expression: "notifyAll"
                                      }
                                    ],
                                    attrs: {
                                      id: "notify_all",
                                      type: "checkbox"
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.notifyAll)
                                        ? _vm._i(_vm.notifyAll, null) > -1
                                        : _vm.notifyAll
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = _vm.notifyAll,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.notifyAll = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.notifyAll = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.notifyAll = $$c
                                          }
                                        },
                                        _vm.onNotifyAll
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", { attrs: { for: "notify_all" } })
                                ]),
                                _vm._v(
                                  "\n                            Notify\n                        "
                                )
                              ]
                            }
                          },
                          {
                            key: "head(recommend)",
                            fn: function(scope) {
                              return [
                                _c("span", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.recommendAll,
                                        expression: "recommendAll"
                                      }
                                    ],
                                    attrs: {
                                      id: "recommend_all",
                                      type: "checkbox"
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.recommendAll)
                                        ? _vm._i(_vm.recommendAll, null) > -1
                                        : _vm.recommendAll
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = _vm.recommendAll,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.recommendAll = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.recommendAll = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.recommendAll = $$c
                                          }
                                        },
                                        _vm.onRecommendAll
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "recommend_all" }
                                  })
                                ]),
                                _vm._v(
                                  "\n                            Recommend\n                        "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(name)",
                            fn: function(data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: data.item.add_once ? "add-once" : "",
                                    attrs: {
                                      title: data.item.add_once
                                        ? "Not saved to list."
                                        : ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(data.item.name) +
                                        "\n                            "
                                    ),
                                    data.item.company
                                      ? [
                                          _vm._v(
                                            "\n                                (" +
                                              _vm._s(data.item.company.name) +
                                              ")\n                            "
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "remove-member",
                                    attrs: { id: "removeuser-" + data.item.id }
                                  },
                                  [
                                    _c("icon", {
                                      attrs: { icon: " fa-minus-circle" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-popover",
                                  {
                                    ref: "removeuser-" + data.item.id,
                                    attrs: {
                                      target: "removeuser-" + data.item.id,
                                      triggers: "click"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "my-list-popover" },
                                      [
                                        _vm._v(
                                          "\n                                    Are you sure you want to remove this member from the list?\n                                    "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "yes",
                                            on: {
                                              click: function($event) {
                                                return _vm.removeMember(
                                                  data.item.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Yes")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "no",
                                            on: {
                                              click: function($event) {
                                                return _vm.closeToolTip(
                                                  "removeuser-" + data.item.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("No")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(sendEmail)",
                            fn: function(data) {
                              return [
                                _c("span", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.sendMail,
                                        expression: "sendMail"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "send_email-" + data.item.id
                                    },
                                    domProps: {
                                      value: data.item.id,
                                      checked: Array.isArray(_vm.sendMail)
                                        ? _vm._i(_vm.sendMail, data.item.id) >
                                          -1
                                        : _vm.sendMail
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.sendMail,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = data.item.id,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.sendMail = $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.sendMail = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.sendMail = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "send_email-" + data.item.id }
                                  })
                                ])
                              ]
                            }
                          },
                          {
                            key: "cell(notify)",
                            fn: function(data) {
                              return [
                                _vm.recommend.includes(data.item.id)
                                  ? _c("span", { staticClass: "checkbox" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.notify,
                                            expression: "notify"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "notify-" + data.item.id
                                        },
                                        domProps: {
                                          value: data.item.id,
                                          checked: Array.isArray(_vm.notify)
                                            ? _vm._i(_vm.notify, data.item.id) >
                                              -1
                                            : _vm.notify
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.notify,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = data.item.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.notify = $$a.concat([
                                                    $$v
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.notify = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.notify = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        attrs: { for: "notify-" + data.item.id }
                                      })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "cell(recommend)",
                            fn: function(data) {
                              return [
                                _c("span", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.recommend,
                                        expression: "recommend"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "recommend-" + data.item.id
                                    },
                                    domProps: {
                                      value: data.item.id,
                                      checked: Array.isArray(_vm.recommend)
                                        ? _vm._i(_vm.recommend, data.item.id) >
                                          -1
                                        : _vm.recommend
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.recommend,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = data.item.id,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.recommend = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.recommend = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.recommend = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "recommend-" + data.item.id }
                                  })
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2142101656
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { padding: "0px 15px" }
                      },
                      [
                        _c("div", { staticClass: "col-md-12 member" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12 list-actions" },
                              [
                                _vm.addUserButton
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "add-button link",
                                        attrs: { href: "#!" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.addMember()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Add Member\n                                        "
                                        ),
                                        _c("icon", {
                                          attrs: { icon: " fa-plus-circle" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sendListButton
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "link pull-right",
                                        attrs: { href: "#!" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.sendList()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Send List\n                                        "
                                        ),
                                        _c("icon", {
                                          attrs: { icon: " fa-paper-plane" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "link text-danger pull-right",
                                    attrs: {
                                      id: "confirmDeleteList",
                                      href: "#!"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.confirmDeleteList = !_vm.confirmDeleteList
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Delete List\n                                        "
                                    ),
                                    _c("icon", { attrs: { icon: " fa-trash" } })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "link pull-right",
                                    attrs: {
                                      href: _vm.$laravelRoute(
                                        "favourites.index",
                                        { tag_id: _vm.tagId }
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        View Vehicles\n                                        "
                                    ),
                                    _c("icon", { attrs: { icon: " fa-eye" } })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-popover",
                                  {
                                    attrs: {
                                      show: _vm.confirmDeleteList,
                                      target: "confirmDeleteList",
                                      triggers: "click"
                                    },
                                    on: {
                                      "update:show": function($event) {
                                        _vm.confirmDeleteList = $event
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "my-list-popover" },
                                      [
                                        _vm._v(
                                          "\n                                            This will delete the list along with it's members and vehicles. Are you\n                                            sure?\n                                            "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "yes",
                                            on: { click: _vm.deleteList }
                                          },
                                          [_vm._v("Yes")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "no",
                                            on: {
                                              click: function($event) {
                                                _vm.confirmDeleteList = false
                                              }
                                            }
                                          },
                                          [_vm._v("No")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.addUser
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-6 col-md-12 input-area mb-3"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.userName,
                                          expression: "userName"
                                        }
                                      ],
                                      ref: "user_search_input",
                                      staticClass: "textbox w-100",
                                      attrs: {
                                        type: "text",
                                        name: "userName",
                                        placeholder: "Start typing to search",
                                        id: "userName"
                                      },
                                      domProps: { value: _vm.userName },
                                      on: {
                                        keyup: function($event) {
                                          return _vm.getUsers()
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.userName = $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-6 col-md-12 d-flex align-items-center"
                                  },
                                  [
                                    _c("span", { staticClass: "checkbox" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.salesRep,
                                            expression: "salesRep"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          name: "sales_rep",
                                          id: "sales-rep"
                                        },
                                        domProps: {
                                          checked: Array.isArray(_vm.salesRep)
                                            ? _vm._i(_vm.salesRep, null) > -1
                                            : _vm.salesRep
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.getUsers()
                                          },
                                          change: function($event) {
                                            var $$a = _vm.salesRep,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.salesRep = $$a.concat([
                                                    $$v
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.salesRep = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.salesRep = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { attrs: { for: "sales-rep" } },
                                        [_vm._v("Filter by Sales Rep")]
                                      )
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.getUserList
                            ? _c(
                                "div",
                                { staticClass: "row user-detail" },
                                _vm._l(_vm.getUserList, function(user) {
                                  return _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c("div", { staticClass: "row detail" }, [
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "span",
                                            { staticClass: "member-name" },
                                            [_vm._v(_vm._s(user.name))]
                                          ),
                                          _vm._v(" "),
                                          user.company
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(user.company.name) +
                                                    ")"
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 link" },
                                          [
                                            _vm.selectedRow
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "save-list",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.saveToList(
                                                            user.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Save to list")]
                                                  ),
                                                  _vm._v(
                                                    " |\n                                                "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "add-once",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addOnce(
                                                            user.id,
                                                            user.name,
                                                            user.company
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    Add once\n                                                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [_vm._v(" ")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b7ba861", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b7ba861","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Favourites/FavouritesListPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3b7ba861","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Favourites/FavouritesListPage.vue
// module chunks = 0